import { workerInfoType } from "../../components/singleInput/SingleInputMain";
import { ACTIVE, Dirary } from "../../types/dirary";
export const createDefaultDiary = (
  workerInfo: any,
  workingDate: string,
  fromTime: string,
  toTime: string,
  totalTime: { hour: number; min: number; text: string },
  hasBreak: boolean,
  breakTime: number,
  productNo: string,
  productBno: string,
  factoryNo: number,
  construction: number,
  slipNumber: string
) => {
  console.log("default", workerInfo);
  if (workerInfo.workerName === "" || !workerInfo.workerName) {
    return nullADiaryList();
  }
  return {
    id: 0,
    workerId: workerInfo.workerId,
    workerName: workerInfo.workerName,
    departmentId: workerInfo.departmentId,
    affiliationFactoryId: workerInfo.place,
    jobId: workerInfo.jobId,
    workingDate: workingDate,
    factoryId: factoryNo,
    constructionId: construction,
    startTime: fromTime,
    endTime: toTime,
    isBreak: hasBreak,
    breakTime: breakTime,
    totalWorkingTimeByHour: totalTime.hour,
    totalWorkingTimeByMinute: totalTime.min,
    productNo: productNo,
    productBno: productBno,
    siteName: "未設定",
    processName: "未設定",
    processId: "0000",
    estimatedTime: 0,
    workingTimeByHour: 0.5,
    workingTimeByMinute: 30,
    comment: "",
    slipNumber: slipNumber,
    isSendable: false,
    isDisabled: false,
    status: ACTIVE,
  };
};

export const nullADiaryList = (): Dirary => {
  return {
    id: 9999,
    workerId: "",
    workerName: "",
    departmentId: 0,
    affiliationFactoryId: 0,
    jobId: 1,
    workingDate: "",
    factoryId: 0,
    constructionId: 0,
    startTime: "",
    endTime: "",
    isBreak: false,
    breakTime: 0,
    totalWorkingTimeByHour: 0,
    totalWorkingTimeByMinute: 0,
    productNo: "",
    productBno: "",
    siteName: "",
    processName: "",
    processId: "",
    estimatedTime: 0,
    workingTimeByHour: 0,
    workingTimeByMinute: 0,
    comment: "",
    slipNumber: "0000000",
    isSendable: false,
    isDisabled: false,
    status: ACTIVE,
  };
};

export const createDefaultDiaryForMulti = (
  workingDate: string,
  fromTime: string,
  toTime: string,
  totalTime: { hour: number; min: number; text: string },
  hasBreak: boolean,
  breakTime: number,
  productNo: string,
  productBno: string,
  factoryNo: number,
  construction: number,
  slipNumber: string
) => {
  return {
    id: 0,
    workerId: "",
    workerName: "",
    departmentId: 0,
    affiliationFactoryId: 0,
    jobId: 1,
    workingDate: workingDate,
    factoryId: factoryNo,
    constructionId: construction,
    startTime: fromTime,
    endTime: toTime,
    isBreak: hasBreak,
    breakTime: breakTime,
    totalWorkingTimeByHour: totalTime.hour,
    totalWorkingTimeByMinute: totalTime.min,
    productNo: productNo,
    productBno: productBno,
    siteName: "未設定",
    processName: "未設定",
    processId: "0000",
    estimatedTime: 0,
    workingTimeByHour: 0.5,
    workingTimeByMinute: 30,
    comment: "",
    slipNumber: slipNumber,
    isSendable: false,
    isDisabled: false,
    status: ACTIVE,
  };
};
